import React from "react";

const ModuleToggleButton = ({
  title,
  description,
  onClick,
  className,
  active,
}) => {
  const titleSort = title
    .trim()
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
  return (
    <button
      className={`cursor-pointer p-3 ${active ? "bg-neutrals-50/70" : ""}`}
      onClick={onClick}
    >
      <div className="flex gap-2.5 items-center mr-2 hover:mr-0 hover:ml-2 transition-all duration-300">
        <div
          className={`w-10 h-10 rounded-sm bg-primary text-white font-medium flex items-center justify-center p-1 ${className}`}
        >
          {titleSort}
        </div>
        <div className="flex flex-col justify-center gap-1">
          <h6 className="text-left whitespace-nowrap">{title}</h6>
          <p className="card-label-small text-left  whitespace-nowrap">
            {description}
          </p>
        </div>
      </div>
    </button>
  );
};

export default ModuleToggleButton;
